<template>
    <transition name="fade" v-if="is_open">
        <div class="cookies-popup">
            <div class="box">
                <div class="text" v-html="$store.state.cookies"></div>
                <div class="close-btn">
                    <router-link to="/privacy-policy/" class="ui-button">usage</router-link>
                    <span class="ui-button" @click.native="close(true)">accept all</span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Button from '@/components/ui/Button.vue';

export default {
    name: 'cookies',
    components: {
        Button,
    },
    data() {
        return {
            is_open: true,
        }
    },
    methods: {
        close(is_hide = false) {
            this.$emit('close');
            this.is_open = false;

            if (is_hide) window.localStorage.setItem('hide_cookies_new', 1);
        },
    },

}
</script>

<style lang="scss">

    .cookies-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        padding: var(--padding-x2);
        background: var(--yellow);
        box-sizing: border-box;
        width: 100%;
        font-weight: bold;

        .close-btn {
            display: flex;
            align-items: center;
            padding-left: var(--padding-x2);
        }

        .box {
            display: flex;
            align-items: center;

            strong {
                color: white;
            }
        }

        .ui-button {
            cursor: pointer;
            color: white;
            border-color: white;
            white-space: nowrap;
            margin-left: var(--padding);

            &:hover {
                border-color: var(--font-color);
                color:  white;
            }
        }
    }

    @media only screen and (max-width: 780px) {

        .cookies-popup .box{
            display: block ;
        }
        .text{
            padding-bottom: 30px;
        }
        .close-btn{
            padding-left: var(--padding-x3);
        }
    }

</style>
